<script>
  import Card from "../components/card.svelte";
  export let providerId = 0;

  
</script>

<Card>
  <div slot="header">
    <h3>Completed</h3>
  </div><div slot="body">
    <div class="form-group">
      <p>The configuration has now been set up successfully. If this is the first sync, or significant changes have been made, please allow a few hours for the sync to complete. </p>
      <p>To review what has been set up, please click the 'View Summary' button below. </p>
    </div>
      <div>
        <a class="btn btn-primary" href="/app/export/{providerId}/summary">View Summary</a>
    </div>
  
  </div>
</Card>
  